const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000'

// Document attached to a quote or an offer. Matches the storage service
// response shape so it can be rendered directly by DocumentViewer (mimeType).
export interface AttachedDocument {
  name: string
  url: string
  key?: string
  mimeType: string
  size?: number
  uploaded_at?: string
  uploaded_by_name?: string
}

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('access_token')
  return { Authorization: `Bearer ${token}` }
}

async function uploadTo(endpoint: string, file: File): Promise<AttachedDocument> {
  const formData = new FormData()
  formData.append('file', file)

  const response = await fetch(`${API_URL}${endpoint}`, {
    method: 'POST',
    headers: authHeaders(), // do not set Content-Type for FormData
    body: formData,
  })

  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || 'Erro ao enviar documento')
  }

  const data = await response.json()
  return data.document as AttachedDocument
}

// Shipper attaches a document to a quote (used by the new-quote wizard).
export function uploadQuoteDocument(file: File): Promise<AttachedDocument> {
  return uploadTo('/upload/quote-document', file)
}

// Freight forwarder attaches a document to an offer.
export function uploadOfferDocument(file: File): Promise<AttachedDocument> {
  return uploadTo('/upload/offer-document', file)
}
